import React from "react";
import Navbar from "../Components/Navbar"; // Assuming shared Navbar is used
import Footer from "../Components/Footer"; // Assuming shared Footer is used
import "../Styling/CN.css"; // Reuse existing styles
import { CheckCircle } from "lucide-react"; // Import a nice icon
import { Link } from "react-router-dom";

const ThankYou = () => {
    return (
        <div style={{ backgroundColor: "#0F172A", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <Navbar />

            <div className="container" style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "4rem 2rem"
            }}>

                <div style={{
                    marginBottom: "2rem",
                    color: "#5B4CFF" // Primary color
                }}>
                    <CheckCircle size={80} strokeWidth={1.5} />
                </div>

                <h1 style={{
                    color: "#FFFFFF",
                    fontSize: "3rem",
                    fontWeight: "800",
                    marginBottom: "1rem"
                }}>
                    Thank You!
                </h1>

                <p style={{
                    color: "#CBD5E1", // Text muted
                    fontSize: "1.2rem",
                    maxWidth: "600px",
                    marginBottom: "3rem",
                    lineHeight: "1.6"
                }}>
                    Your submission has been received. Our team will review your request and get back to you shortly.
                </p>

                <Link to="/" className="CN-cta-button" style={{
                    padding: "1rem 2.5rem",
                    fontSize: "1.1rem",
                    display: "inline-block"
                }}>
                    Back to Home
                </Link>

            </div>

            <Footer />
        </div>
    );
};

export default ThankYou;
